import script from "./InvoiceList.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceList.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceList.vue?vue&type=style&index=0&id=65604dac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65604dac"]])

export default __exports__